import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CrfLibrary from "./components/CrfLibrary/CrfLibrary";
import FormBuilder from "./components/FormBuilder/FormBuilder";
import NocReport from "./components/nocReport/nocReport";
import CdeCatalog from "./components/CdeCatalog/CdeCatalog";
import CdeDetails from "./components/CdeDetails/cdeDetails";
import withCartProvider from "./components/hoc/withCartProvider";
import Instructions from "./components/FormBuilder/Instructions";
import Cart from "./components/FormBuilder/Cart";
import CrfListing from "./components/CrfListing/crfListing";
import Roster from "./components/Roster/roster";
import Glossary from "./components/Glossary/glossary";

import '@iframe-resizer/child';

function App() {
  return (
    <div className="main-container">
      <BrowserRouter basename="/ninds">
        <Routes>
          <Route path="/" element={<div>Homepage</div>} />
          <Route
            path="cde-catalog"
            element={<CdeCatalog />}
          />
          <Route
            path="cde-details/:reportType/"
            element={<CdeDetails />}
          />
          <Route
            path="crf-library"
            element={<CrfLibrary />}
          />
          <Route
            path="form-builder"
            element={<FormBuilder />}
          >
            <Route path="instructions" element={<Instructions />} />
            <Route path="cart" element={<Cart />} />
          </Route>
          <Route
            path="noc-report/:crfId/:crfName"
            element={<NocReport />}
          />
          <Route
            path="crf-listing/:diseaseId"
            element={<CrfListing />}
          />
          <Route
            path="roster/:diseaseId"
            element={<Roster />}
          />
          <Route 
            path="glossary"
            element={<Glossary />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default withCartProvider(App);
